import Mapir from "mapir-react-component";

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE5YjA2ODBkODYyMGJjZDA1NTVmZTI2MTU0ZmNhMzZjN2JhZDczM2UwNWU4YzNkZGMzYWI4OTY2Njc5OTE1ODNkODE4NzM1MGYxMWFjYjUzIn0.eyJhdWQiOiIxMzc2MCIsImp0aSI6ImE5YjA2ODBkODYyMGJjZDA1NTVmZTI2MTU0ZmNhMzZjN2JhZDczM2UwNWU4YzNkZGMzYWI4OTY2Njc5OTE1ODNkODE4NzM1MGYxMWFjYjUzIiwiaWF0IjoxNjE5NjE2MjQ2LCJuYmYiOjE2MTk2MTYyNDYsImV4cCI6MTYyMjIwODI0Niwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.EoyIafo7XIcscez5x5BO7J3mXHdYUg2Vl8sND8Ge401-ACVJDORupfhP_bzj4NomftRii98NglQUQa6ym_3WQi3XubJBvUNkxinHfXUJ8q9sltU382rSyzj7AOBCdIlgqR8M1by1Q48cf6fsrhzMwTWlFDhZxUBMQPTtRtUY1dlolABTYhEuQamRibmMKUOJZrQH4nfxMuiKwM19xTxc2Zv-hf5aCk9sbMBEfNXmeUTpPo9-86tH5PahGnAJQbr_Kv17kaA7_HBHPWXweWXpwC_xHqsodXjYeL-M3VCjTTwVzefkjcQs_b0xPKyrHqZzBH2Uc8VY0CI9C_n4p-kYIA",
        "Mapir-SDK": "reactjs",
      },
    };
  },
});

export default Map;
